import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-five-stars',
  templateUrl: './five-stars.component.html',
  styleUrls: ['./five-stars.component.scss']
})
export class FiveStarsComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
